import Card from './components/Card';
import { jsx as _jsx } from "react/jsx-runtime";
export default Card;
export const renderCard = options => ({
  data
}) => /*#__PURE__*/_jsx(Card, {
  options: options,
  data: data
});